import * as dayjs from 'dayjs';
import * as moment from 'moment';
import { DashboardRanges, RangesDate } from 'src/app/models/dashboard.model';

export const BALANCE_STATUS_OPTIONS = [
  {
    value: 'withdrawal',
    label: 'Withdrawal',
    id: 'withdrawal',
    checked: false,
  },
  {
    value: 'order_received',
    label: 'COD Orders (Received)',
    id: 'Received',
    checked: false,
  },
  {
    value: 'order_returned',
    label: 'COD Orders (Return)',
    id: 'Retur',
    checked: false,
  },
  {
    value: 'order_shipping',
    label: 'Non-COD Orders (Shipping Cost)',
    id: 'Ongkir',
    checked: false,
  },
  {
    value: 'order_cancel',
    label: 'Non-COD Orders (Canceled)',
    id: 'Cancel',
    checked: false,
  },
  {
    value: 'insurance_fee',
    label: 'Insurance',
    id: 'Insurance',
    checked: false,
  },
  {
    value: 'top_up',
    label: 'Top Up',
    id: 'TopUp',
    checked: false,
  },
  {
    value: 'payment_order_bank_transfer',
    label: 'Payment Orders (Bank Transfer)',
    id: 'BankTransfer',
    checked: false,
  },
  {
    value: 'payment_order_qris',
    label: 'Payment Orders (QRIS)',
    id: 'Qris',
    checked: false,
  },
  {
    value: 'generate_qris',
    label: 'QRISLY',
    id: 'Qrisly',
    checked: false,
  },
  {
    value: 'gosend_price_difference',
    label: 'Price Difference',
    id: 'gosend_price_difference',
    checked: false,
  },
  {
    value: 'order_damaged',
    label: 'Damaged Package Compensation',
    id: 'Damaged',
    checked: false,
  },
  {
    value: 'order_missing',
    label: 'Lost Package Compensation',
    id: 'Missing',
    checked: false,
  },
];

export const DEFAULT_TRANSACTION_TYPES = BALANCE_STATUS_OPTIONS.map((item) => item.value).join(',');

export const BALANCE_DATE_RANGES: DashboardRanges = {
  Today: [moment().startOf('day'), moment().endOf('day')],
  Yesterday: [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
  'Last 7 Days': [moment().subtract(6, 'days').startOf('day'), moment().endOf('day')],
  'Last 30 Days': [moment().subtract(29, 'days').startOf('day'), moment().endOf('day')],
  'This Month': [moment().startOf('month'), moment().endOf('month')],
  'Last Month': [
    moment().subtract(1, 'month').startOf('month'),
    moment().subtract(1, 'month').endOf('month'),
  ],
};
